import React from "react";
import withAnimation from "../../utils/withAnimation";
import { Alert } from "@op/opds.opux";
import { Message } from "react-message-context";

const FormError = () => {
  return (
    <Alert
      type="critical"
      className="rof-formError"
      contentType="static"
      role="alert"
    >
      <Message id="feedback.form.error.row1" />
      <br />
      <Message id="feedback.form.error.row2" />
    </Alert>
  );
};

export const FormErrorNoAnimation = FormError;
export default withAnimation(FormError);
